import { watch } from 'vue';

import { useFormData } from '@/composables/formData';
import { i18n } from '@/i18n';

export function usePromoCode(code = '') {
    const { state, reset } = useFormData({
        code,
        capture: i18n.t('exchange-form.promo.label').toString(),
        hint: '',
        error: false,
    });

    watch(() => state.data.code, () => {
        if (!state.data.code) {
            reset();
        }
    });

    return {
        state,
    };
}
